import React, { useState, useEffect } from "react";
import Alert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { getError } from "../../state/selectors";

interface Props {}

export default function Error({}: Props) {
  const error = useSelector(getError());
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch({
      type: "SEARCH_FAILED",
      error: null
    });
  };

  return (
    <Snackbar open={!!error} autoHideDuration={6000} onClose={onClose}>
      <Alert onClose={onClose} severity="error">
        <span>{error}</span>
      </Alert>
    </Snackbar>
  );
}
